import React from 'react';

function Cv({ CvContent, hashedUserId, ImageUrl, LanguageSelected, t, divstyle }) {

    const openPDFInNewWindow = () => {
        const pdfUrl = `${ImageUrl}/${hashedUserId}/${CvContent[0].FilePath}`;
        window.open(pdfUrl, '_blank');

    };

console.log('watch--------------------',divstyle)

    return (
        <div>

            {CvContent != null &&
                <div className={`pt-5 pb-5 pl-3 pr-3  w-full`}>
                    <div className="pb-0 pb-3">
                        <div className='flex justify-between items-center '>
                            <h1
                                className={`${LanguageSelected === 'ar'
                                    ? 'title title--h1 first-title title__separate text-theme right-2'
                                    : 'title left-2 title--h1 first-title title__separate text-theme'
                                    }`}>
                                {t("Cv")}
                            </h1>

                         
                        </div>



                        <div className="text flex items-center  p-1">
                                <a onClick={(e) => { openPDFInNewWindow() }} className={`flex h-20 justify-center items-center  ${divstyle == 'div-sections' ? 'sections' : 'div-sections'} w-full  rounded-md px-5`}>
                                    <div className='w-5/6 gap-4 h-full flex justify-start items-center'>
                                        <img src='https://png.pngtree.com/png-clipart/20220612/original/pngtree-pdf-file-icon-png-png-image_7965915.png' className='w-12 h-12' alt='pdf image' />

                                        <p className='font-[700] text-lg text-theme'>{t('Download my CV')}</p>

                                    </div>
                                    <div className='w-1/6 h-full  flex justify-end items-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                        </svg>


                                    </div>

                                </a>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default Cv;
